import { Point, ColorUtils, Rectangle } from '@awayjs/core';
import { BitmapImage2D } from '@awayjs/stage';
var TextureAtlas = /** @class */ (function () {
    function TextureAtlas() {
        this.availableRows = 256;
        this.gradient_row = -1;
        this.color_row = 255;
        this.color_position = 256;
        this.availableGradients = 256;
        this.availableColors = 0;
        this.bitmap = new BitmapImage2D(256, 256, true, 0xff0000);
        this.availableRows = 256;
        this.availableColors = 0;
    }
    TextureAtlas.clearAllMaterials = function () {
        for (var key in TextureAtlas._allColors) {
            TextureAtlas._allColors[key].material = null;
        }
        for (var key in TextureAtlas._allGradients) {
            TextureAtlas._allGradients[key].material = null;
        }
    };
    TextureAtlas.getTextureForColor = function (color, alpha) {
        var colorString = color.toString() + '#' + alpha.toString();
        if (TextureAtlas._allColors.hasOwnProperty(colorString)) {
            return TextureAtlas._allColors[colorString];
        }
        // find textureAtlas that has empty space:
        var t_len = TextureAtlas._allTextureAtlas.length;
        var t = 0;
        var textureAtlas;
        for (t = 0; t < t_len; t++) {
            if (TextureAtlas._allTextureAtlas[t].fit_color()) {
                textureAtlas = TextureAtlas._allTextureAtlas[t];
                break;
            }
        }
        if (!textureAtlas) {
            textureAtlas = new TextureAtlas();
            TextureAtlas._allTextureAtlas.push(textureAtlas);
        }
        var newColorObj = {
            colorPos: textureAtlas.draw_color(color, alpha),
            bitmap: textureAtlas.bitmap,
            material: null,
            uvRectangle: null
        };
        TextureAtlas._allColors[colorString] = newColorObj;
        return newColorObj;
    };
    TextureAtlas.getTextureForGradient = function (gradient) {
        var gradientStr = gradient.toString();
        if (TextureAtlas._allGradients.hasOwnProperty(gradientStr)) {
            gradient.uvRectangle = TextureAtlas._allGradients[gradientStr].uvRectangle;
            return TextureAtlas._allGradients[gradientStr];
        }
        var t_len = TextureAtlas._allTextureAtlas.length;
        var t = 0;
        var textureAtlas;
        for (t = 0; t < t_len; t++) {
            if (TextureAtlas._allTextureAtlas[t].fit_gradient()) {
                textureAtlas = TextureAtlas._allTextureAtlas[t];
                break;
            }
        }
        if (!textureAtlas) {
            textureAtlas = new TextureAtlas();
            TextureAtlas._allTextureAtlas.push(textureAtlas);
        }
        textureAtlas.draw_gradient(gradient);
        var newColorObj = {
            colorPos: null,
            bitmap: textureAtlas.bitmap,
            material: null,
            uvRectangle: new Rectangle()
        };
        newColorObj.uvRectangle.copyFrom(gradient.uvRectangle);
        TextureAtlas._allGradients[gradientStr] = newColorObj;
        return newColorObj;
    };
    TextureAtlas.prototype.fit_gradient = function () {
        return (this.availableRows > 0);
    };
    TextureAtlas.prototype.fit_color = function () {
        if (this.availableColors > 0)
            return true;
        return (this.availableRows > 0);
    };
    TextureAtlas.prototype.draw_gradient = function (gradient) {
        if (this.availableRows < 0) {
            console.log('error in TextureAtlasManager.draw_color');
            return;
        }
        this.gradient_row++;
        this.availableRows--;
        var px;
        for (px = 0; px < 256; px++) {
            this.bitmap.setPixelFromArray(px, this.gradient_row, gradient.getColorAtPosition(px));
        }
        this.bitmap.invalidate();
        gradient.uvRectangle.x = 1 / 512;
        gradient.uvRectangle.y = 1 / 512 + (this.gradient_row / 256); //+1/512;
        gradient.uvRectangle.width = 1 - 1 / 512;
        gradient.uvRectangle.height = gradient.uvRectangle.y;
        return this.availableRows;
    };
    TextureAtlas.prototype.draw_color = function (color, alpha) {
        if (alpha === void 0) { alpha = 1; }
        this.color_position--;
        if (this.color_position < 0) {
            if (this.availableRows > 0) {
                this.color_row--;
                this.availableRows--;
                this.color_position = 255;
            }
            else {
                console.log('error in TextureAtlasManager.draw_color');
            }
        }
        var argb = ColorUtils.float32ColorToARGB(color);
        argb[0] = alpha;
        this.bitmap.setPixelFromArray(this.color_position, this.color_row, argb);
        this.bitmap.invalidate();
        return new Point(1 / 512 + this.color_position / 256, 1 / 512 + this.color_row / 256);
    };
    TextureAtlas._allTextureAtlas = [];
    TextureAtlas._allGradients = {};
    TextureAtlas._allColors = {};
    return TextureAtlas;
}());
export { TextureAtlas };
